import { get } from "lodash";
import { useQuery } from "shared/hooks/useApi";
import { COVERAGE_CATEGORIES } from "utils/api/graphql/queries/coverage-categories";
import { PROCESS } from "utils/api/graphql/queries/processes";
import { PROCESS_CONFIG_TYPES } from "utils/constants";
import Loading from "../Components/Spin";
import View from "./View";

const Needs = ({ project, onNext, onBack, tracer }) => {
  const processId = get(tracer, "flow.process.id");

  const { data: categoriesData, loading: categoriesLoading } = useQuery(
    COVERAGE_CATEGORIES,
    {
      variables: { where: { processId }, gt: { weight: 0 } },
    },
  );

  const { data: processData, loading: processLoading } = useQuery(PROCESS, {
    variables: { where: { id: processId } },
    skip: !processId,
  });

  const needsConfig = get(processData, "process.config", []).find(
    ({ type }) => type === PROCESS_CONFIG_TYPES.NEEDS,
  );

  const needsLevels = get(needsConfig, "value.needsLevels") || 3;
  const labels = get(needsConfig, "value.labels", {});

  const categoriesConfig = get(needsConfig, "value.categories", {});

  if (categoriesLoading || processLoading) return <Loading />;

  return (
    <View
      categories={get(categoriesData, "coverageCategories.data") || []}
      fields={get(project, "fields", {})}
      onNext={onNext}
      onBack={onBack}
      needsLevels={needsLevels}
      labels={labels}
      categoriesConfig={categoriesConfig}
      locked={project.locked}
    />
  );
};

export default Needs;
